
    import Vue from "vue";
    import LogType from "@/models/api/logType/LogType";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import { AxiosError } from "axios";
    import { SnackbarService } from '../../services/SnackbarService';
    import { LogTypeService } from '../../services/LogTypeService';
    import { DataTableHelper } from '@/helpers/DataTableHelper';
    import FakeInput from '@/components/ui/FakeInput.vue';
    import SelectListItem from '../../models/SelectListItem';
    import { LogLevels } from '../../models/Enums';

    export default Vue.extend({
        components: {
            FakeInput,
        },
        data() {
            return {
                items: new Array<LogType>(),

                tableHeaders: [
                    {
                        text: "logType.logType", value: "name", sortable: false
                    },
                    {
                        text: "logType.logLevel", value: "logLevel", sortable: false
                    },
                    {
                        text: "", value: "actions", sortable: false
                    },
                ],
                isTableLoading: false,
                showDateEdit: false,
                editDialogOpen: false,
                editItem: new LogType(),
                registerFormValid: false,

                logLevels: [] as SelectListItem[],

                rules: {
                    required: (value: any) => !!value || this.$vuetify.lang.t('$vuetify.required'),

                },

            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.tableHeaders, this);

            this.logLevels = [];
            Object.values(LogLevels).map((n: string | LogLevels) => {
                if (typeof LogLevels[n as any] === 'number') {
                    this.logLevels.push(new SelectListItem(this.getLogLevelName(LogLevels[n as any]), LogLevels[n as any]));
                }
            });

            this.getAll();
        },
        watch: {
            editDialogOpen: {
                handler(open: boolean) {

                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
        },
        methods: {
            getLogLevelName(logLevel: any): string {
                return this.$vuetify.lang.t('$vuetify.logType.' + LogLevels[logLevel]) as string;
            },
            prepareEdit(item: LogType): void {
                // Use object assign in order to separate the modified item with existing item.
                // Keeps row in datatable the same, whilst updating the values.
                Object.assign(this.editItem, item);
            },
            async save(item: LogType) {
                LogTypeService.SaveLogType(item).then(
                    (result) => {
                        this.getAll();
                        this.editDialogOpen = false;                       
                        SnackbarService.addSuccessMessage(result?.data);
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async getAll() {
                this.isTableLoading = true;
                this.items = (await LogTypeService.GetLogTypes()).data;
                this.isTableLoading = false;
                
            },
        },
    })


